import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ApprovalEngineListRBACPage = {
  pageID: '0c0d4f21f32ec0e4f9d8cc1306163177',
  elementID: {
    ViewListPage: '22787bb59475cad89cf64981d0ba0703',
  },
} as const

export const useApprovalEngineListRBACPage = createUseRBAC(ApprovalEngineListRBACPage.elementID)

export type UseApprovalEngineListRBACPageType = ReturnType<typeof useApprovalEngineListRBACPage>
